import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useAllMyCoursesData, MY_COURSES_MODE } from 'Domain/MyCourseData';
import EmptyCourses from 'Containers/EmptyCourses';
import { CourseBannerTitle } from 'Components/MyCourses';

import CourseList from '../../Components/CourseList';
import CourseContainer from '../../Components/CourseContainer';

import DashboardNavigation, { VARIANT } from './DashboardNavigation';
import DashboardBackground from './DashboardBackground';
import RecentCourses from './RecentCourses';

const SpacingDashboardBackground = styled(DashboardBackground)`
  padding-top: ${({ theme }) =>
    `calc(${theme.space.NAVBAR_HEIGHT}px + ${theme.space.APP_TOP_OFFSET}px)`};
`;

const SpacingEmptyCourses = styled(EmptyCourses)`
  padding-top: 0;
  height: ${({ theme }) =>
    `calc(100vh - 24px - ${theme.space.NAVBAR_HEIGHT}px + ${theme.space.APP_TOP_OFFSET}px)`};
`;

const SpacingRecentCourses = styled(RecentCourses)`
  #course-banners {
    padding-bottom: ${({ theme }) => theme.space[1]}px;
    :first-child {
      padding-left: ${({ theme }) => theme.space[4]}px;
    }
    :last-child {
      padding-right: ${({ theme }) => theme.space[4]}px;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints[2]}) {
      :first-child {
        padding-left: ${({ theme }) => theme.space[7]}px;
      }
      :last-child {
        padding-right: ${({ theme }) => theme.space[7]}px;
      }
    }
  }
`;

const Dashboard = () => {
  const history = useHistory();
  const { t } = useTranslation('myCourses');
  const { data: myCourses } = useAllMyCoursesData({ mode: MY_COURSES_MODE.ALL });

  if (myCourses?.length === 0) {
    return (
      <>
        <DashboardNavigation variant={VARIANT.FLAT} />
        <SpacingEmptyCourses mt={6} />
      </>
    );
  }

  return (
    <>
      <DashboardNavigation variant={VARIANT.DYNAMIC}>{t('BANNER.TITLE1')}</DashboardNavigation>
      <SpacingDashboardBackground pb={5}>
        <CourseBannerTitle
          title={t('BANNER.TITLE1')}
          subTitle={t('BANNER.TITLE2')}
          mb={3}
          px={{ _: 4, lg: 7 }}
        />
        <SpacingRecentCourses />
      </SpacingDashboardBackground>
      <CourseContainer px={{ _: 4, lg: 7 }} py={6}>
        <CourseList history={history} mt={0} pb={0} px={0} />
      </CourseContainer>
    </>
  );
};

export default Dashboard;
